import { render } from "./Breadcrumbs.vue?vue&type=template&id=32c0a560&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=32c0a560&lang=scss&scoped=true"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c0a560"]])

export default __exports__